module.exports = __webpack_public_path__ + "files/6e22925953f17ce22aea27b42c05cd0a.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/code_themes/monokai.png
// module id = 580
// module chunks = 60